import router from "../router";
import store from "../store";
import { SIGNOUT_USER_SUCCESS } from "../store/mutation-types";

export default promise =>
  promise
    .then(response => [null, response.data])
    .catch(err => {
      if (err.response && err.response.status === 401) {
        store.commit("auth/" + SIGNOUT_USER_SUCCESS);
        router.push("/login");
        return [[]];
      } else {
        return [["خطا در برقراری ارتباط با سرور!"]];
      }
    });
